import React from 'react'
import classes from './TemplateIdCell.module.scss'
import { Cell } from '@/components/ui/Table'
import Button from '@/components/ui/Buttons/Button'
import { useCopyUrlToClipboard } from '@/app/routes/Templates/TemplateIdCell/TemplateIdCell.hooks'

export type TemplateIdCellProps = {
  templateId: number
}

export const TemplateIdCell = ({ templateId }: TemplateIdCellProps) => {
  const copyUrlToClipboard = useCopyUrlToClipboard(templateId)
  return (
    <Cell size={'80px'}>
      <Button
        variant={'plain'}
        color={'neutral'}
        className={classes.root}
        data-tooltip-id="tooltip"
        data-tooltip-content={'Copy template URL to clipboard'}
        data-tooltip-delay-show={600}
        onClick={copyUrlToClipboard}
      >
        {templateId}
      </Button>
    </Cell>
  )
}
